import { render, staticRenderFns } from "./allocation_config_types.vue?vue&type=template&id=ece4a11a&scoped=true&"
import script from "./allocation_config_types.vue?vue&type=script&lang=js&"
export * from "./allocation_config_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece4a11a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece4a11a')) {
      api.createRecord('ece4a11a', component.options)
    } else {
      api.reload('ece4a11a', component.options)
    }
    module.hot.accept("./allocation_config_types.vue?vue&type=template&id=ece4a11a&scoped=true&", function () {
      api.rerender('ece4a11a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/allocation_config_types.vue"
export default component.exports